export default __webpack_public_path__ + "static/media/creme2.4c9567e2.jpg";